import CrossSell from './CrossSell'

export default CrossSell
